import { ReactNode, RefObject, useMemo } from "react";
import { useNavigation } from "react-router-dom";

import { IgLinearProgress } from "@intelligems/ig-theme";
import { Grid, styled, SxProps } from "@mui/material";
import { IgPageContentTopBar } from "@src/utils/IgPageContentTopBar";

const Root = styled("div")(({ theme }) => ({
  width: "100%",
  minHeight: "100svh",
  display: "flex",
  flexDirection: "column",
  paddingTop: theme.spacing(4),
  backgroundColor: theme.igBackgroundColors.baseLightMid,
  boxSizing: "border-box",
}));

interface IgPageContentProps {
  children: ReactNode;
  childrenSx?: SxProps;
  paddingX?: number;
  igPageContentRef?: RefObject<null>;
}

export const IgPageContent = (props: IgPageContentProps) => {
  const { state } = useNavigation();
  const { children, igPageContentRef, childrenSx, paddingX, ...rest } = props;
  const isLoadingRoute = state === "loading";

  return (
    <Root id={"ig-page-content"} sx={{ position: "relative" }} {...rest}>
      {isLoadingRoute && (
        <IgLinearProgress
          sx={{ position: "absolute", top: 0, left: 0, width: "100%" }}
        />
      )}

      <Grid
        rowSpacing={4}
        sx={{
          height: "100%",
          flexWrap: "nowrap",
          flex: 1,
          paddingX: paddingX ?? 10,
        }}
        container
        direction={"column"}
      >
        <IgPageContentTopBar />

        <Grid
          ref={igPageContentRef}
          id={"ig-page-content-scrollable"}
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            ...childrenSx,
          }}
        >
          {children}
        </Grid>
      </Grid>
    </Root>
  );
};
